exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".MyDropZone{min-height:50px!important}.smallPreviewImg{height:100;width:\"initial\";max-width:340%!important}.grid-container{display:grid;grid-template-columns:auto auto auto auto;grid-gap:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/Products/styles.scss
// module id = 1486
// module chunks = 0